import ChevronLeft from "../../../atoms/icon/icons/chevron_left.svg";
import Close from "../../../atoms/icon/icons/close.svg";
import { IconButton } from "atoms/icon-button/IconButton";
import { useTranslation } from "@/core/i18n";

export interface PersonalisationProgressBarProps {
  progressPercentage?: number;
  onBack?: () => void;
  onClose?: () => void;
}

export const PersonalisationProgressBar = ({
  progressPercentage,
  onBack,
  onClose,
}: PersonalisationProgressBarProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-8 px-1.5 pt-4">
      {/* Back Button - 44x44 with 24x24 icon */}
      {onBack ? (
        <div className="flex h-12 w-12 items-center justify-center">
          <IconButton
            svg={ChevronLeft}
            size="small"
            style="iconOnly"
            onClick={onBack}
            aria-label={t("common.back")}
          />
        </div>
      ) : (
        <div className="h-12 w-12" />
      )}

      {/* Progress Bar */}
      {progressPercentage !== undefined ? (
        <div className="flex-1">
          <div className="relative h-[5px] w-full rounded-full bg-light-grey">
            <div
              className="absolute h-full rounded-full bg-brand-color"
              style={{
                width: `${Math.min(100, Math.max(0, progressPercentage))}%`,
              }}
            />
          </div>
        </div>
      ) : (
        <div className="flex-1" />
      )}

      {/* Close Button */}
      {onClose ? (
        <button
          onClick={onClose}
          className="flex h-12 w-12 items-center justify-center rounded-full hover:bg-black/5"
        >
          <Close className="h-6 w-6" />
        </button>
      ) : (
        <div className="h-12 w-12" />
      )}
    </div>
  );
};
